import { MessageType } from '@i18nspect/types';
import { addMessageListener } from './utils';
// Number inspector
var onSetLanguage = function (cb) {
    return addMessageListener({
        type: MessageType.Number_OnSetLanguage,
        callback: cb,
    });
};
var hover = function (payload) {
    window.postMessage({
        type: MessageType.Number_Hover,
        payload: payload,
    });
};
export default {
    onSetLanguage: onSetLanguage,
    hover: hover,
};
